var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('header-content',{attrs:{"header-info":_vm.headerInfo}},[_c('header-content-addition',{attrs:{"addition":_vm.headerInfo}})],1),_c('div',{staticClass:"faq-list-wrapper"},[_c('faq-list',{attrs:{"is-page":_vm.isPage}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }